/**
 * Approved German copy for the Lexar case-study page. Loaded last so it
 * overrides any earlier machine-generated wording for these strings.
 */
const dict: Record<string, string> = {
  // Hero
  "How Lexar achieved ROAS (return on ad spend) ≈12x at an ad spend ratio of 8.2% using promo code tracking":
    "Wie Lexar mit Promo-Code-Tracking einen ROAS von ≈12x bei einer Werbekostenquote von 8,2 % erzielte",
  "Below is a case study on promoting the Lexar brand in the electronics category (storage devices: USB flash drives, memory cards, SSDs) on marketplaces. The case does not disclose budget, turnover (GMV), or average order value in rubles. Only relative performance indicators (ROAS, ad spend ratio) are shown.":
    "Nachfolgend finden Sie eine Fallstudie zur Promotion der Marke Lexar in der Kategorie Elektronik auf Marketplaces, genauer gesagt für Speicherprodukte wie USB-Sticks, Speicherkarten und SSDs. In dieser Fallstudie werden weder Budget noch Umsatz (GMV) oder durchschnittlicher Bestellwert in Rubel offengelegt. Gezeigt werden ausschließlich relative Performance-Kennzahlen wie ROAS und Werbekostenquote.",
  "≈12x": "≈12x",
  "8.2%": "8,2 %",

  // Client's Task
  "Brand: Lexar, electronics category, storage devices with a low average order value.":
    "Marke: Lexar, Kategorie Elektronik, Speicherprodukte mit niedrigem durchschnittlichem Bestellwert.",
  "Lexar brand | CPA starting model": "Marke Lexar | CPA-Ausgangsmodell",

  // Hypotheses
  "The final hypothesis, which was confirmed: promo codes combined with specialized affiliate partners work effectively even in a low-ticket storage category.":
    "Die finale Hypothese, die sich bestätigt hat: Promo-Codes in Kombination mit spezialisierten Affiliate-Partnern funktionieren auch in einer niedrigpreisigen Kategorie für Speicherprodukte effektiv.",

  // How It Worked
  "The best results came from promo code tracking on the brand's flash drives and memory cards.":
    "Die besten Ergebnisse erzielte das Promo-Code-Tracking bei den USB-Sticks und Speicherkarten der Marke.",

  // Results
  "ROAS (return on ad spend) for the case overall: around 12x.":
    "ROAS (Return on Ad Spend) der gesamten Fallstudie: rund 12x.",
  "Ad spend ratio for the case overall: about 8.2%.":
    "Werbekostenquote der gesamten Fallstudie: rund 8,2 %.",
  "Turnover is built steadily from a broad range of low-priced items: flash drives, memory cards, and SSDs.":
    "Der Umsatz entsteht kontinuierlich aus einem breiten Sortiment niedrigpreisiger Produkte: USB-Sticks, Speicherkarten und SSDs.",
  "The team found a working arrangement with affiliate partners and is scaling it, growing turnover well beyond the starting point.":
    "Das Team hat ein funktionierendes Modell mit Affiliate-Partnern gefunden und skaliert dieses weiter. Dadurch wächst der Umsatz deutlich über das Ausgangsniveau hinaus.",

  // Conclusions
  "Promo code tracking combined with affiliate partners works even in a low-ticket category: it delivers a high ROAS at a moderate ad spend ratio.":
    "Promo-Code-Tracking in Kombination mit Affiliate-Partnern funktioniert auch in einer niedrigpreisigen Kategorie: Das Modell erzielt einen hohen ROAS bei einer moderaten Werbekostenquote.",
  "Unlike premium categories, efficiency here is built not on a single top model but on a wide assortment of low-priced items.":
    "Anders als in Premium-Kategorien basiert die Effizienz hier nicht auf einem einzelnen Top-Produkt, sondern auf einem breiten Sortiment niedrigpreisiger Artikel.",
  "Scaling the promo code network is what's driving the shift toward stronger, steadier turnover.":
    "Die Skalierung des Promo-Code-Netzwerks ist der entscheidende Faktor für den Übergang zu einem höheren und stabileren Umsatz.",

  // Scaling Opportunities
  "Expand promo code coverage within the storage device lineup, where the potential is not yet fully used.":
    "Die Promo-Code-Abdeckung innerhalb des Sortiments an Speicherprodukten erweitern, da das Potenzial dort noch nicht vollständig ausgeschöpft ist.",

  // Related case cards
  "How Lamobile achieved 15x ROAS using promo code tracking":
    "Wie Lamobile mit Promo-Code-Tracking einen ROAS von 15x erzielte",
  "How Roborock achieved 17x ROAS with promo code tracking":
    "Wie Roborock mit Promo-Code-Tracking einen ROAS von 17x erzielte",
  "How WalkingPad achieved 18x ROAS with promo code tracking":
    "Wie WalkingPad mit Promo-Code-Tracking einen ROAS von 18x erzielte",
};

export default dict;
